export const DEBUG_MODE = false; // Cambia in false in produzione

export const server = {
    url: "http://localhost/api/",
    timeout: 10000
};

if(DEBUG_MODE)
{
    server.url = "http://localhost/SPORTING-NEW/php_files/";
} 
else
    server.url = "https://www.sportingsaluzzo.it/php_files/";
